import { Link } from 'react-router-dom'
import { getPlanLabel } from '../../lib/labels.js'
import type { MeTenant } from '../../lib/me-api.js'
import { SettingsSectionCard } from './SettingsSectionCard.js'

type Props = {
  tenant: MeTenant
}

export function SettingsPlanSection({ tenant }: Props) {
  if (tenant.kind === 'EPHEMERAL' || tenant.plan === 'EPHEMERAL') {
    return null
  }

  const planLabel = getPlanLabel(tenant.plan)

  return (
    <SettingsSectionCard
      title="プラン"
      description="現在のプランと、有料プランへの変更手続きです。"
    >
      <div className="space-y-3">
        <p className="text-sm">
          現在のプラン: <span className="font-medium">{planLabel}</span>
          {tenant.plan === 'PRO' && tenant.addonStorageTb > 0 && (
            <span className="text-muted-foreground">
              {' '}
              （追加ストレージ {tenant.addonStorageTb} TB）
            </span>
          )}
        </p>

        {tenant.plan === 'PRO' ? (
          <p className="text-sm text-muted-foreground">
            追加ストレージなどのご相談は、下の「運営に問い合わせる」からご連絡ください。
          </p>
        ) : (
          <>
            <p className="text-sm text-muted-foreground">
              プロジェクト数無制限・容量 2TB から、追加 1TB 単位で拡張できます。
            </p>
            <Link
              to="/upgrade"
              className="inline-flex items-center gap-2 px-4 py-2 bg-primary text-primary-foreground rounded-md text-sm font-medium hover:opacity-90 transition-opacity"
            >
              プラン変更を申し込む →
            </Link>
          </>
        )}
      </div>
    </SettingsSectionCard>
  )
}
